module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commit gl-responsive-table-row"
  }, [_c('div', {
    staticClass: "table-section section-10 commit-link"
  }, [_c('div', {
    staticClass: "table-mobile-header",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Status\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mobile-content"
  }, [_c('ci-badge', {
    attrs: {
      "status": _vm.pipelineStatus
    }
  })], 1)]), _vm._v(" "), _c('pipeline-url', {
    attrs: {
      "pipeline": _vm.pipeline
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-section section-25"
  }, [_c('div', {
    staticClass: "table-mobile-header",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Commit\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mobile-content"
  }, [_c('commit-component', {
    attrs: {
      "tag": _vm.commitTag,
      "commit-ref": _vm.commitRef,
      "commit-url": _vm.commitUrl,
      "short-sha": _vm.commitShortSha,
      "title": _vm.commitTitle,
      "author": _vm.commitAuthor
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-section section-wrap section-15 stage-cell"
  }, [_c('div', {
    staticClass: "table-mobile-header",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Stages\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mobile-content"
  }, _vm._l((_vm.pipeline.details.stages), function(stage) {
    return (_vm.pipeline.details.stages.length > 0) ? _c('div', {
      staticClass: "stage-container dropdown js-mini-pipeline-graph"
    }, [_c('pipeline-stage', {
      attrs: {
        "stage": stage,
        "update-dropdown": _vm.updateGraphDropdown
      }
    })], 1) : _vm._e()
  }))]), _vm._v(" "), _c('pipelines-timeago', {
    attrs: {
      "duration": _vm.pipelineDuration,
      "finished-time": _vm.pipelineFinishedAt
    }
  }), _vm._v(" "), (_vm.displayPipelineActions) ? _c('div', {
    staticClass: "table-section section-20 table-button-footer pipeline-actions"
  }, [_c('div', {
    staticClass: "btn-group table-action-buttons"
  }, [(_vm.pipeline.details.manual_actions.length) ? _c('pipelines-actions-component', {
    attrs: {
      "actions": _vm.pipeline.details.manual_actions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pipeline.details.artifacts.length) ? _c('pipelines-artifacts-component', {
    staticClass: "hidden-xs hidden-sm",
    attrs: {
      "artifacts": _vm.pipeline.details.artifacts
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pipeline.flags.retryable) ? _c('async-button-component', {
    attrs: {
      "endpoint": _vm.pipeline.retry_path,
      "css-class": "js-pipelines-retry-button btn-default btn-retry",
      "title": "Retry",
      "icon": "repeat"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pipeline.flags.cancelable) ? _c('async-button-component', {
    attrs: {
      "endpoint": _vm.pipeline.cancel_path,
      "css-class": "js-pipelines-cancel-button btn-remove",
      "title": "Cancel",
      "icon": "remove",
      "confirm-action-message": "Are you sure you want to cancel this pipeline?"
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97d30852"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table_row.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-97d30852"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table_row.vue
// module chunks = commit_pipelines pipelines